import React from 'react';
import { string, oneOf, node } from 'prop-types';
import { WEB_SYSTEM_URL } from 'constants/environments';
import { Gray, Green, Purple } from 'constants/colors';
import newLogo from 'assets/images/new_logo.png';
import julioImg from 'assets/images/julio.png';

import {
  ButtonWithIcon, 
  Container, 
  Footer,
  Text,
} from 'components';

export default function Completed({ managerName, managerEmail }) {

  return (
    <>
      <Container
        style={{
          margin: '0',
          textAlign: 'center',
          backgroundColor: Gray[200],
          height: '100%',
          padding: '40px',
          width: '100%',
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <div
          style={{
            width: '70%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            gap: '24px',
            padding: '24px',
            borderRadius: '8px',
            backgroundColor: Gray[100],
            border: `1px solid ${Gray[250]}`,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              width: "40%",
            }}
          >
            <img
              src={newLogo}
              alt="New Logo"
              style={{ width: '90px', height: '40px' }}
            />
            <Text
              fontSize="42px"
              fontWeight="900"
              textAlign="left"
              color={Green[400]}
              lineHeight="125%"
              style={{
                marginBottom: '12px',
                whiteSpace: 'normal',
                overflowWrap: 'normal',
                wordBreak: 'normal'
              }}
            >
              OBRIGADO PELA CONTRATAÇÃO! 🎉
            </Text>
            <div>
              <Text
                fontSize="16px"
                color={Gray[400]}
                textAlign="left"
                lineHeight="21px"
                style={{
                  marginBottom: '16px',
                  whiteSpace: 'normal',
                  overflowWrap: 'normal',
                  wordBreak: 'normal'
                }}
              >
                {managerName || "Cliente"}, agradecemos pela confiança em nosso serviço.
              </Text>
              <Text
                fontSize="16px"
                color={Gray[400]}
                textAlign="left"
                lineHeight="21px"
                style={{
                  marginBottom: '16px',
                  whiteSpace: 'normal',
                  overflowWrap: 'normal',
                  wordBreak: 'normal'
                }}
              >
                Assim que o pagamento for identificado, vamos te enviar os próximos passos diretamente para o e-mail {managerEmail || "cliente@exemplo.com"}.
              </Text>
              <Text
                fontSize="16px"
                color={Gray[400]}
                textAlign="left"
                lineHeight="21px"
                style={{
                  marginBottom: '16px',
                  whiteSpace: 'normal',
                  overflowWrap: 'normal',
                  wordBreak: 'normal'
                }}
              >
                Fique de olho na sua caixa de entrada (e também no spam, por precaução).
              </Text>
            </div>
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: "40%",
          }}>
            <div style={{
              borderRadius: '50%',
              overflow: 'hidden',
            }}>
              <img
                src={julioImg}
                alt="Julio César"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>

            <div style={{
              padding: '6px 12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '12px',
              textAlign: 'center',
              marginTop: '-20px'
            }}>
              <Text fontSize="14px" fontWeight="600" color={Gray[700]}>
                Julio César
              </Text>
              <Text fontSize="12px" color={Gray[500]}>
                CEO Contele Fleet
              </Text>
            </div>
          </div>
        </div>
      </Container>

      <Footer padding="16px 24px">
        <ButtonWithIcon
          customBackgroundColor={Purple[500]}
          icon="arrowRight"
          title="Acessar Contele Fleet"
          onClick={() => {
            const pathAfterLogin = "/aproveitamento";
            const token = localStorage.getItem("auth_token");
            const queryParams = `pathAfterLogin=${pathAfterLogin}&token=${token}`;

            window.open(`${WEB_SYSTEM_URL}/login?${queryParams}`, "_self")
          }}
        />
      </Footer>
    </>
  );
}

Completed.defaultProps = {
  title: 'Contrato recebido com Sucesso!',
  content: null,
};

Completed.propTypes = {
  title: string,
  content: oneOf([node, string]),
};
